(()=>{'use strict';
if(window.ggEvening110)return;window.ggEvening110=true;
const el=document.getElementById('GGEveningConfig'),M=window.GGEveningModel;if(!el||!M)return;
let cfg;try{cfg=JSON.parse(el.textContent)}catch{return}const p=cfg.products;if(Object.values(p).some(x=>!x.id))return;
const base=window.Shopify?.routes?.root||'/',raw=window.fetch.bind(window),money=n=>new Intl.NumberFormat('pl-PL',{style:'currency',currency:'PLN'}).format(n/100);
let cart,busy=false,pending=0,timer,error='',message='';const esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
async function api(path,body){const r=await raw(base+path,{credentials:'same-origin',cache:'no-store',headers:body?{'Content-Type':'application/json'}:{},...(body?{method:'POST',body:JSON.stringify(body)}:{})});const data=await r.json();if(!r.ok)throw Error(data.description||'Nie udało się zmienić koszyka. Spróbuj ponownie.');return data}
function render(){
 if(!cart)return;
 const c=M.counts(cart,p),offers=M.offers(cart,p),saved=M.savings(cart,p);
 const handles={g:'zbrodnia-w-garwolinie',n:'sprawa-neptuna',b:'zestaw-wydzialu-sledczego-grobla',z:'zgrzyt'};
 document.querySelectorAll('[data-gg-evening]').forEach(host=>{
  host.hidden=!cart.item_count||cart.currency!=='PLN';
  host.innerHTML=(offers.length?'<h3>Dobierz do wieczoru</h3>':'')+offers.map(o=>{
   const url=esc(base+'products/'+handles[o.product]+(o.product==='b'?'?view=gg-bundle':''));
   return `<div class="gg-evening-row"><a class="gg-evening-product-image" href="${url}" aria-label="Zobacz ${esc(o.title)}"><img src="${esc(p[o.product].image)}" alt="" width="42" height="48"></a><div><a class="gg-evening-product-title" href="${url}"><strong>${esc(o.title)}</strong></a><small>${o.kind==='zgrzyt'?(c.b?'−50%':'−30%'):'Zamiana gry na zestaw'}</small></div><button type="button" class="gg-evening-add" data-gg-offer="${o.kind}" ${busy?'disabled':''}><span>${o.kind==='bundle'?'Zamień':'Dodaj'}</span>+${money(o.delta)}</button></div>`;
  }).join('')+(saved?`<p class="gg-evening-save"><span>Oszczędzasz</span><strong>${money(saved)}</strong></p>`:'')+`<p class="gg-evening-status" role="status">${busy?'Aktualizujemy koszyk…':''}</p>`+(error?`<p class="gg-evening-error" role="alert">${esc(error)}</p>`:'');
 });
}

function lock(value){busy=value;document.documentElement.classList.toggle('gg-evening-lock',value);render()}
// Bundle is added first: a stock error never removes the customer's existing games.
async function replaceWithBundle(snapshot,quantity,types){
 const token='gg117-'+Date.now()+'-'+Math.random().toString(36).slice(2);
 const lines=(state,id)=>state.items.filter(i=>M.eligible(i,p)&&Number(i.variant_id)===id);
 const total=(state,id)=>lines(state,id).reduce((sum,i)=>sum+i.quantity,0);
 const before=Object.fromEntries(types.map(id=>[id,total(snapshot,id)]));
 if(types.some(id=>before[id]<quantity))throw Error('Nie znaleziono gry do zamiany.');
 await api('cart/add.js',{items:[{id:p.b.id,quantity,properties:{_gg_pair:token}}]});
 try{
  const now=await api('cart.js');
  // Discounts can change line keys and split identical variants into several lines.
  if(types.some(id=>total(now,id)!==before[id]))throw Error('Liczba gier w koszyku zmieniła się. Sprawdź koszyk i spróbuj ponownie.');
  const updates={};
  for(const id of types){let remaining=quantity;for(const line of lines(now,id)){const take=Math.min(remaining,line.quantity);if(take)updates[line.key]=line.quantity-take;remaining-=take;}}
  try{await api('cart/update.js',{updates})}catch(e){
   const check=await api('cart.js');
   if(!types.every(id=>total(check,id)===before[id]-quantity))throw e;
  }
 }catch(e){
  const now=await api('cart.js'),line=now.items.find(i=>i.properties?._gg_pair===token);
  if(line)await api('cart/change.js',{id:line.key,quantity:0});
  throw e;
 }
}
function reload(){if(document.querySelector('cart-drawer.active'))sessionStorage.setItem('gg110-open','1');sessionStorage.setItem('gg110-message',message);location.reload()}
async function refresh(){
 if(busy)return;
 lock(true);
 try{
  cart=await api('cart.js');
  error='';
  const pairs=M.pairCount(cart,p);
  if(cart.currency==='PLN'&&p.b.price===17900&&p.g.price===9900&&p.n.price===9900&&p.b.available&&pairs){
   await replaceWithBundle(cart,pairs,[Number(p.g.id),Number(p.n.id)]);
   message='';
   reload();
   return;
  }
  render();
 }catch(e){error=e.message;render()}
 finally{lock(false)}
}
document.addEventListener('click',async e=>{const btn=e.target.closest('[data-gg-offer]');if(!btn)return;e.preventDefault();if(busy)return;lock(true);error='';try{cart=await api('cart.js');const offer=M.offers(cart,p).find(o=>o.kind===btn.dataset.ggOffer);if(!offer)throw Error('Oferta zmieniła się. Sprawdź aktualny koszyk.');if(offer.kind==='zgrzyt'){await api('cart/add.js',{items:[{id:p.z.id,quantity:1}]});message=''}else{const c=M.counts(cart,p);await replaceWithBundle(cart,1,[Number(c.g?p.g.id:p.n.id)]);message='Zamieniliśmy grę na zestaw. Oszczędzasz 19 zł.'}reload()}catch(e){error=e.message;cart=await api('cart.js').catch(()=>cart);lock(false)}},true);
// Observe successful native cart requests, preserving their original responses.
window.fetch=async function(input,init){const url=new URL(typeof input==='string'?input:(input.url||String(input)),location.href),mutation=url.origin===location.origin&&/\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname);if(mutation)pending++;try{return await raw(input,init)}finally{if(mutation){clearTimeout(timer);timer=setTimeout(async()=>{pending=0;await refresh()},350)}}};
document.addEventListener('click',e=>{if((busy||pending)&&e.target.closest('[name="checkout"],a[href*="/checkout"],cart-remove-button,quantity-input')){e.preventDefault();e.stopImmediatePropagation()}},true);
document.addEventListener('submit',e=>{if((busy||pending)&&e.target.matches('form[action*="cart"]')){e.preventDefault();e.stopImmediatePropagation()}},true);
window.addEventListener('pageshow',refresh);document.addEventListener('visibilitychange',()=>{if(!document.hidden)refresh()});
try{message=sessionStorage.getItem('gg110-message')||'';if(message.startsWith('Dodano ZGRZYT'))message='';sessionStorage.removeItem('gg110-message');if(sessionStorage.getItem('gg110-open')){sessionStorage.removeItem('gg110-open');setTimeout(()=>document.querySelector('cart-drawer')?.open(),150)}}catch{}
refresh();
})();

// GG_CART_112: linked offers and quiet success state.

// GG_CART_116_LINKS


/* GG_CART_124_MOBILE_NAME_AND_TOUCH */
(()=>{
 'use strict';
 if(window.ggCartTouch124)return;window.ggCartTouch124=true;
 const selector=':is(#CartDrawer,cart-items.gg-brand-cart,#main-cart-footer) a:is(.cart-item__name,.gg-evening-product-title)';
 let link=null,start=null,timer;
 function clear(){clearTimeout(timer);link?.classList.remove('gg124-touch');link=null;start=null;}
 document.addEventListener('pointerdown',event=>{
  if(event.pointerType!=='touch'&&event.pointerType!=='pen')return;
  clear();link=event.target.closest(selector);if(!link)return;
  start={x:event.clientX,y:event.clientY,id:event.pointerId};link.classList.add('gg124-touch');
 },{passive:true});
 document.addEventListener('pointermove',event=>{
  if(start&&event.pointerId===start.id&&Math.hypot(event.clientX-start.x,event.clientY-start.y)>10)clear();
 },{passive:true});
 document.addEventListener('pointerup',()=>{if(link)timer=setTimeout(clear,300)},{passive:true});
 document.addEventListener('pointercancel',clear,{passive:true});
 window.addEventListener('pageshow',clear);
 // Native link navigation remains immediate; scrolling is never intercepted.
})();

// GG_NO_FREE_SHIPPING_128


// GG_AUTO_BUNDLE_131
